module.exports = __webpack_public_path__ + "img/lk.9018cbe9.svg";